import React from "react";

import OnasBlock from "../../components/PageBlocks/MoreInfoPages/OnasBlock/OnasBlock";
import { API_BASE_URL } from "../../context/appState";
import ServicePanel from "../../components/CommonBlocks/Panel/ServicePanel";

const OnasPage = props => (
    <div className="o_nas" style={{display:'flex'}}>
        <ServicePanel />
        <OnasBlock initialData={props.initialData} />
    </div>
);

OnasPage.getInitialProps = async function(context) {
    // let res = await fetch(`${API_BASE_URL}/section/o-nas/`);
    // const json = await res.json();
    return {
        // initialData: json,
        title: "О нас",
        description: "",
        keywords: "",
        pageClasses: "relative_wrapper o_nas_page_wrapper",
        namespacesRequired: ['services']
    };
};

export default OnasPage;
